import { queryOptions } from '@tanstack/react-query';

import { fetcher } from '@/_lib/fetcher';

export interface DownloadMouseScreenshotQueryOptions {
  actionId: string;
}

export const DOWNLOAD_MOUSE_SCREENSHOT_QUERY_ROOT_KEY = ['download-mouse-screenshot'];

export const getDownloadMouseScreenshotQueryKey = ({ actionId }: DownloadMouseScreenshotQueryOptions) => [
  ...DOWNLOAD_MOUSE_SCREENSHOT_QUERY_ROOT_KEY,
  actionId
];

const getDownloadMouseScreenshot = async ({ actionId }: { actionId: string }) => {
  return fetcher.get<{ screenshot_url: string }>(`actions/${actionId}/download_mouse_screenshot`);
};

export const getDownloadMouseScreenshotQueryOptions = ({ actionId }: DownloadMouseScreenshotQueryOptions) =>
  queryOptions({
    queryKey: getDownloadMouseScreenshotQueryKey({ actionId }),
    queryFn: () => getDownloadMouseScreenshot({ actionId })
  });
